import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export function FinalCTA() {
  return <section className="relative py-32 md:py-48 overflow-hidden bg-[#08080a]" data-id="element-10">
      {/* Deep Gradient Background */}
      <div className="absolute inset-0 bg-gradient-to-b from-transparent to-[#0a0a0b]" data-id="element-11" />
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-[800px] h-[500px] bg-amber-500/10 rounded-full blur-[150px] pointer-events-none" data-id="element-12" />
      <div className="absolute inset-0 bg-[url('https://grainy-gradients.vercel.app/noise.svg')] opacity-10 mix-blend-overlay pointer-events-none" data-id="element-13" />

      <div className="container mx-auto px-6 relative z-10" data-id="element-14">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} whileInView={{
        opacity: 1,
        scale: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        ease: [0.16, 1, 0.3, 1]
      }} className="max-w-4xl mx-auto text-center" data-id="element-15">
          <h2 className="text-4xl md:text-6xl lg:text-7xl font-bold text-zinc-100 mb-8 tracking-tight" data-id="element-16">
            El Internet Cambió Mi Vida.
            <br data-id="element-17" />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-amber-200 to-amber-500" data-id="element-18">
              También Puede Cambiar la Tuya.
            </span>
          </h2>

          <p className="text-lg md:text-xl text-zinc-400 mb-12 max-w-2xl mx-auto" data-id="element-19">
            Da el primer paso hoy. Aprende las habilidades, aplica la disciplina
            y comienza a construir tu futuro en la economía digital.
          </p>

          <a href="https://www.skool.com/affiliatewave/about?ref=32124321f1d54df7b2eef01cab5ffbf9" target="_blank" rel="noopener noreferrer" className="group inline-flex items-center justify-center gap-3 px-10 py-5 bg-amber-400 text-[#0a0a0b] rounded-full font-bold text-lg hover:bg-amber-300 transition-all shadow-[0_0_30px_rgba(251,191,36,0.2)] hover:shadow-[0_0_50px_rgba(251,191,36,0.3)] hover:-translate-y-1" data-id="element-20">
            Conoce Más
            <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-21" />
          </a>
        </motion.div>
      </div>
    </section>;
}